import { CategoriesApi } from '../../generated/api';
import configuration from './configuration';

const categoriesService = new CategoriesApi(configuration);

export default categoriesService;
